import { DataTable, DataTableColumn } from 'cpool-components/general/DataTable';
import { Empty } from 'cpool-components/state/Empty';
import { useTranslation } from 'react-i18next';
import { LuFileSearch } from 'react-icons/lu';

import { DocumentRow } from './DocumentRow';
import type { SchemaRecordedDocumentsList } from '~/features/leadDetails/schemas/recordedDocuments.schema';

type Props = {
    documents: SchemaRecordedDocumentsList;
    hasSecondApplicant: boolean;
    leadId: string;
};

export const DocumentsTable: React.FC<Props> = ({ documents, hasSecondApplicant, leadId }) => {
    const { t } = useTranslation();

    if (documents.length === 0)
        return (
            <Empty
                className="mx-auto my-8"
                noBorder
                icon={<LuFileSearch />}
                title={t('DOCUMENT_DEMANDER.SUMMARY.EMPTY')}
                description={t('DOCUMENT_DEMANDER.SUMMARY.EMPTY_HINT')}
            />
        );

    return (
        <DataTable className="overflow-x-auto">
            <DataTableColumn name={t('DOCUMENT_DEMANDER.SUMMARY.HEADER.CONFIRMATION')} field="confirmed" sortable />
            <DataTableColumn name={t('DOCUMENT_DEMANDER.SUMMARY.HEADER.FILE_NAME')} field="fileName" sortable />
            <DataTableColumn name={t('DOCUMENT_DEMANDER.SUMMARY.HEADER.FILE_FORMAT')} field="fileFormat" sortable />
            <DataTableColumn
                name={t('DOCUMENT_DEMANDER.SUMMARY.HEADER.UPLOAD_DATE')}
                field="uploadDate"
                sortable
                sortType="numerical"
            />
            <DataTableColumn
                name={t('DOCUMENT_DEMANDER.SUMMARY.HEADER.CONFIRMATION_DATE')}
                field="confirmedDate"
                sortable
                sortType="numerical"
            />
            {hasSecondApplicant && (
                <DataTableColumn
                    name={t('DOCUMENT_DEMANDER.SUMMARY.HEADER.ATTRIBUTION')}
                    field="attribution"
                    sortable
                />
            )}
            <DataTableColumn
                name={t('DOCUMENT_DEMANDER.SUMMARY.HEADER.UPLOAD_STATUS')}
                field="uploadStatus"
                align="center"
            />
            <DataTableColumn name="" field="actions" align="center" />
            {documents.map((document) => (
                <DocumentRow
                    key={document.key}
                    document={document}
                    hasSecondApplicant={hasSecondApplicant}
                    leadId={leadId}
                    payload={{
                        attribution: document.attribution,
                        confirmed: document.confirmedDate !== null,
                        // -1 sorts unconfirmed documents before every real timestamp.
                        confirmedDate: document.confirmedDate ? document.confirmedDate.getTime() : -1,
                        fileFormat: document.fileFormat ?? '',
                        fileName: document.fileName,
                        uploadDate: document.uploadDate.getTime(),
                    }}
                />
            ))}
        </DataTable>
    );
};
